import React from "react";

const PAGE_INFO = {
  revenue: { title: "Revenue", description: "Track income, invoices, and payment status" },
  expenses: { title: "Expenses", description: "Monitor operational costs and vendor payments" },
  customers: { title: "Customers", description: "Manage customer directory and contact info" },
  equipment: { title: "Equipment & Maintenance", description: "Log equipment status and maintenance schedules" },
  supplies: { title: "Materials & Supplies", description: "Track inventory levels and supplier orders" },
  inventory: { title: "Inventory", description: "Track product inventory and stock levels" },
};

const styles = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "calc(100vh - 120px)",
    padding: 40,
  },
  card: {
    background: "#FFFFFF",
    border: "2px solid #0A0A0F",
    borderRadius: 0,
    padding: "60px 48px",
    textAlign: "center",
    maxWidth: 480,
    width: "100%",
  },
  iconWrap: {
    width: 64,
    height: 64,
    borderRadius: 0,
    background: "#FFFFFF",
    border: "2px solid #0A0A0F",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 24,
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    color: "#0A0A0F",
    marginBottom: 8,
    fontFamily: "'Archivo', sans-serif",
  },
  desc: {
    fontSize: 16,
    color: "rgba(10,10,15,0.58)",
    marginBottom: 28,
    lineHeight: 1.5,
  },
  badge: {
    display: "inline-block",
    padding: "6px 18px",
    borderRadius: 0,
    background: "#F4F2EC",
    color: "#0033FF",
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: 0.5,
  },
};

export default function PlaceholderPage({ section }) {
  const info = PAGE_INFO[section] || { title: section, description: "" };
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#0033FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <line x1="12" y1="8" x2="12" y2="16" />
            <line x1="8" y1="12" x2="16" y2="12" />
          </svg>
        </div>
        <h2 style={styles.title}>{info.title}</h2>
        <p style={styles.desc}>{info.description}</p>
        <span style={styles.badge}>Coming Soon</span>
      </div>
    </div>
  );
}
